import log from 'loglevel'
import axios from 'axios'

/* eslint class-methods-use-this: ["off"] */

export default class Contact {
  constructor() {
    log.info('[INFO] Initialize Contact Module')
  }

  fetchContacts(params) {
    let parameters = {}

    if (params) {
      parameters = {
        params,
      }
    }

    return new Promise((resolve, reject) => {
      axios
        .get('v1/contact/', parameters)
        .then(response => {
          log.debug('[DEBUG] Success to fetch contacts')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch contacts')
          log.error(error)
          reject(error.response)
        })
    })
  }

  fetchContact(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`v1/contact/${id}/`)
        .then(response => {
          log.debug('[DEBUG] Success to fetch contact')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch contact')
          log.error(error)
          reject(error.response)
        })
    })
  }

  updateContact(id, contactData) {
    return new Promise((resolve, reject) => {
      axios
        .put(`v1/contact/${id}/`, contactData)
        .then(response => {
          log.debug('[DEBUG] Success to update contact')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to update contact')
          log.error(error)
          reject(error.response)
        })
    })
  }

  addContact(contactData) {
    return new Promise((resolve, reject) => {
      axios
        .post('v1/contact/', contactData)
        .then(response => {
          log.debug('[DEBUG] Success to add contact')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to add contact')
          log.error(error)
          reject(error.response)
        })
    })
  }

  deleteContact(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`v1/contact/${id}/`)
        .then(() => {
          log.debug('[DEBUG] Success to delete contact')
          resolve()
        })
        .catch(error => {
          log.error('[ERROR] Fail to delete contact')
          log.error(error)
          reject(error.response)
        })
    })
  }
}
